import { Injectable } from '@angular/core';

import { PlUtil } from '@common/pl-util';

declare let globalThis: any;
@Injectable()
export class PendoLogger {
  user: any = null;

  pendoKey: string;

  constructor() {
    this.pendoKey = PlUtil.getEnvVar('pendo_key', 'pl-pendo-key');
    this.loadPendo();
  }

  loadPendo() {
    if (!(this.pendoKey && this.pendoKey.length)) return;

    const a = document.createElement('script');
    a.type = 'text/javascript';
    a.innerHTML = `
      window.loadPendo = function(apiKey){
        (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
        v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
            y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
      };
    `;
    document.head.appendChild(a);

    globalThis.loadPendo(this.pendoKey);

    globalThis.pendo = globalThis.pendo || [];
  }

  setUser(currentUser: any, accounts: any, kangaUser: any) {
    if (!(this.pendoKey && this.pendoKey.length)) return;

    const userAccount = accounts && accounts.length && accounts[0];
    const account: any = {};
    const kangaUserInfo: any = {};
    if (userAccount) {
      account.id = userAccount.uuid || undefined;
      account.name = userAccount.name || undefined;
      account.type = userAccount.type || undefined;
    }
    if (kangaUser && kangaUser.licenses) {
      kangaUserInfo.licenses = kangaUser.licenses.join(',');
    }
    if (kangaUser && kangaUser.occupation) {
      kangaUserInfo.discipline = kangaUser.occupation;
    }

    const pendo = globalThis.pendo;
    // This function creates anonymous visitor IDs in Pendo unless you change the visitor id field to use your app's values
    // This function uses the placeholder 'ACCOUNT-UNIQUE-ID' value for account ID unless you change the account id field to use your app's values
    // Call this function in your authentication promise handler or callback when your visitor and account id values are available
    // Please use Strings, Numbers, or Bools for value types.
    pendo.initialize({
      visitor: {
        id: currentUser.uuid, // Required if user is logged in, default creates anonymous ID
        email: currentUser.email, // Recommended if using Pendo Feedback, or NPS Email
        full_name: `${currentUser.first_name} ${currentUser.last_name}`, // Recommended if using Pendo Feedback
        // role:         // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
        username: currentUser.username,
        ...kangaUserInfo,
      },

      account: {
        ...account,
        // id:           // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  }
}
